import axios from 'axios';
import {addressTypeAheadApi} from '../../utils/constants/EndPoint';

function AddressTypeaheadService(streetAddress, customerData, appConfig, cb) {
  const id = streetAddress || '';
  const url = `${appConfig.exrServiceApi + addressTypeAheadApi}?address=${id}`;
  return axios.get(url, {
    cancelToken: new axios.CancelToken(cb)
  });
}

export default AddressTypeaheadService;
